export default "__VITE_ASSET__hO6G2heQ__"